import axios from 'axios';
import { refreshJwtToken } from './refreshToken';
import { maybeDecryptResponse } from '../utils/responseCrypto';

const axiosInstance = axios.create({
  baseURL:process.env.REACT_APP_API_URL,
  timeout: 300000,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
 async (config) =>  {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
  
    return config;
  },
 
);

axiosInstance.interceptors.response.use(
  async (response) => {
    response.data = await maybeDecryptResponse(response.data);
    return response;
  },
   async error => {
    const originalRequest = error.config;
    // If 401 and not already tried
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const newToken = await refreshJwtToken();
        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest); // Retry with new token
      } catch (e) {
        // Redirect to login or show message
        //window.location.href = "/";
      }
    }
    let resdata = '';
    if (error?.response) {
      const decript = await maybeDecryptResponse(error?.response?.data);
      resdata = decript.message;
    } else if (error?.message) {
      resdata = error?.message;
    } else {
      resdata = 'An error occurred';
    }
    return Promise.reject(resdata);
  }
);

export default axiosInstance;
